import { toStr } from 'utils/common/String';
import { TFunction } from 'i18next';

import {
  BreakingTimeFromAPI,
  BreakingTimeResponseData,
  EditBreakingTimeRowType,
  EditWorkingTimeFormType,
  TimeAttendanceOfficerFromAPI,
  UpdateAttendanceWorkingTimeRequest,
  UpdateAttendanceBreakingTimeRequest,
  WorkingTimeResponseData,
} from 'types/timeAttendance/timeAttendanceTypes';
import dayjs from 'dayjs';
import { Option } from 'types/common/FormTypes';

export const mapEditWorkingTimeToRequest = (
  values: EditWorkingTimeFormType
): UpdateAttendanceWorkingTimeRequest => {
  return {
    clock_in_at: values.clockInAt
      ? dayjs(values.clockInAt).format('YYYY-MM-DD HH:mm:ss')
      : '',
    clock_out_at: values.clockOutAt
      ? dayjs(values.clockOutAt).format('YYYY-MM-DD HH:mm:ss')
      : '',
    note: values.note?.trim() || '',
  };
};

const parseDateTime = (value?: string | null): Date | null => {
  if (!value) return null;
  if (value.trim() === '' || value === '0000-00-00 00:00:00') return null;

  const parsedDate = new Date(value.replace(' ', 'T'));
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export function mapApiToWokingTimeForm(
  data: WorkingTimeResponseData | null
): EditWorkingTimeFormType {
  if (data == null) {
    return {} as unknown as EditWorkingTimeFormType;
  }
  if (Object.keys(data).length === 0) {
    return {} as unknown as EditWorkingTimeFormType;
  }

  return {
    id: String(data.id),
    officeCode: toStr(data.office_code),
    fullName: toStr(data.full_name),
    clockInAt: parseDateTime(data.clock_in_at),
    clockOutAt: parseDateTime(data.clock_out_at),
    note: toStr(data.note),
  };
}

export const mapApiToBreakingTimeRows = (
  data: BreakingTimeResponseData | null
): EditBreakingTimeRowType[] => {
  if (!data || data.length === 0) return [];

  return data.map(mapApiToBreakingTimeRow);
};

export const mapApiToBreakingTimeRow = (
  item: BreakingTimeFromAPI
): EditBreakingTimeRowType => ({
    id: String(item.id),
    attendanceSessionId: String(item.attendance_session_id),
    breakStartAt: parseDateTime(item.break_start_at),
    breakEndAt: parseDateTime(item.break_end_at),
    breakingHours:
      item.breaking_hours === null || item.breaking_hours === undefined
        ? ''
        : String(item.breaking_hours),
    note: toStr(item.note),
  });

export const mapEditBreakingTimeToRequest = (
  values: EditBreakingTimeRowType
): UpdateAttendanceBreakingTimeRequest => ({
  break_start_at: values.breakStartAt
    ? dayjs(values.breakStartAt).format('YYYY-MM-DD HH:mm:ss')
    : '',
  break_end_at: values.breakEndAt
    ? dayjs(values.breakEndAt).format('YYYY-MM-DD HH:mm:ss')
    : '',

  note: values.note?.trim() || '',
});

export const mapOfficersToSelectOptions = (
  data: TimeAttendanceOfficerFromAPI[] | [],
  t: TFunction
): Array<Option | { label: string; value: null }> => {
  const uniqueOfficers = Array.from(
    new Map(data.map((item) => [item.id, item])).values()
  );

  return [
    { label: t('All'), value: null },
    ...uniqueOfficers.map((item) => ({
      label: item.full_name,
      value: item.id,
    })),
  ];
};
